const dollarUS = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});


export const USDDollarFormat = (dv: number) => {
    return dollarUS.format(dv);
};
